import { Skill } from './skill.type'

export enum Intensity {
    LOW = 'LOW',
    MEDIUM = 'MEDIUM',
    HIGH = 'HIGH',
}

export enum GameType {
    SINGLES = 'SINGLES',
    DOUBLES = 'DOUBLES',
    BOTH = 'BOTH',
}

export enum CourtType {
    FULL = 'FULL',
    HALF = 'HALF',
    BOTH = 'BOTH',
}

export interface Exercise {
    id: number
    title: string
    description: string
    peopleCount: number
    intensity: Intensity
    gameType: GameType
    courtType: CourtType
    skills: Array<{
        skill: {
            id: number
            name: string
            parentSkill: {
                id: number
                name: string
            } | null
        }
    }>
    createdAt: string
    updatedAt: string
}

// Ancien type conservé pour compatibilité
export type SkillExercise = {
    exerciseId: number
    exercise: Exercise
    skillId: number
    skill: Skill
}

export interface ExerciseFormData {
    title: string
    description: string
    peopleCount: number
    intensity: Intensity
    gameType: GameType
    courtType: CourtType
    skillIds: number[]
}
